import { ILatLng, IPoint } from './types';

export function pointToLatLng(point: IPoint): ILatLng {
  return {
    lng: point[0],
    lat: point[1]
  };
}
